/**
 * finite-field — narrow an unknown/unenforced numeric field to a finite number,
 * or null.
 *
 * The analytics summary/occupancy routes carry NO response_model on the backend
 * yet (#1340), so the frontend's hand-typed interfaces are NOT enforced at
 * runtime: a backend/BFF can hand a component `{ utilization_percent: null }`,
 * an absent field, or a string. Formatting such a value fabricates a number that
 * reads as real data — `Math.round(null) === 0` → a fake "0%" (worst: looks like
 * a truthful "empty facility"), `Math.round(undefined)` → "NaN%",
 * `String(undefined)` → "undefined", `Intl.NumberFormat().format(undefined)`
 * → "NaN". The no-hallucinated-numbers rule (content-copy.md) forbids all of
 * these: every displayed number must come from a REAL value or degrade to "—".
 *
 * Gate EVERY unenforced numeric field through this BEFORE formatting; a null
 * result means "render the honest placeholder", never a fabricated figure.
 */
export function finiteOrNull(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null
}
